import api from "./api";

export const empleadoService = {
    getAll: async (empresaId = null, buscar = null) => {
        const params = {};
        if (empresaId) params.empresaId = empresaId;
        if (buscar) params.buscar = buscar;
        const response = await api.get('/empleados', { params });
        return response;
    },
    
    getById: async (id) => {
        const response = await api.get(`/empleados/${id}`);
        return response;
    },

    create: async (empleado) => {
        const response = await api.post('/empleados', empleado);
        return response;
    },

    update: async (id, empleado) => {
        const response = await api.put(`/empleados/${id}`, empleado);
        return response;
    },

    delete: async (id) => {
        const response = await api.delete(`/empleados/${id}`);
        return response;
    },

    createDireccion: async (direccion) => {
        const response = await api.post('/empleados/direccion', direccion);
        return response;
    },

    updateDireccion: async (id, direccion) => {
        const response = await api.put(`/empleados/${id}/direccion`, direccion);
        return response;
    }
}